import { APIService } from "@kluntje/services";
import { appendQueryObject } from "@kluntje/js-utils/lib/url-helpers";
import { HOUR_IN_MS } from "Constants/dateConstants";

import { AnnouncementServiceAPIResponse } from "./AnnouncementService.types";

class AnnouncementService {
  public async getCurrentAnnouncements(): Promise<AnnouncementServiceAPIResponse> {
    const queryUrl = appendQueryObject(`https://announcements.oldsum.de/v2/announcements`, {
      city: "Süderende",
    });

    const apiResponse = await APIService.fetchJSON<AnnouncementServiceAPIResponse>(queryUrl, {
      cacheOptions: { validFor: HOUR_IN_MS },
    });

    if (apiResponse === null) {
      return { public_announcements: [], building_plan_announcements: [] };
    }

    return apiResponse;
  }
}

export default new AnnouncementService();
